import MdaeTextBox from "./component";
import { ITextBoxOptions } from "devextreme-react/text-box";
import { IMdaeDataUpdaterConfig } from "../../mdae-framework";
export interface IMdaeTextBoxProps extends ITextBoxOptions {
  id: string;
  mdaeTextBoxTitle?: string;
  mdaeDataUpdaterConfig?: Array<IMdaeDataUpdaterConfig>;
  required?: boolean;
  madeFieldTitleClassName?:string;
}
export default MdaeTextBox;
